<rk-modal-wrapper
  [showSubmitBlock]="false"
  [title]="'GLOBAL.MODAL.SANTA_TITLE' | translate"
  [santa]="true"
  (closed)="onCancel()"
>
  <div class="container">
    <img src="/assets/santa.png" alt="Santa" />
    <div class="right">
      <div id="form" [class.completed]="completed"></div>
    </div>
  </div>
</rk-modal-wrapper>
